//@flow
import * as React from "react";
import { View } from "react-native";
import * as icon from "../../icon";
import { constants } from "cockpit-shared";
import { H2 } from "../../texts";
import { Tappable } from "../../tappable";
import { NetworkImage } from "../../menu-button/MenuButton";
import "./ChartTab.css";

export type ChartTabProps = {
  id: string,
  iconName: string,
  iconUrl: string,
  selectedTabId: string,
  isDisabled?: boolean,
  name: string,
  style: any,
  selectedTextColor: string,
  notSelectedTextColor: string,
  selectedBackgroundColor: string,
  notSelectedBackgroundColor: string,
  isSelected: Boolean,
  style?: any
};

export const ChartTab = (props: ChartTabProps) => {
  let isSelected = (props.isSelected != null && props.isSelected) || props.id === props.selectedTabId;
  const textColor = isSelected
    ? props.selectedTextColor || constants.colors.w_veryDarkBlue
    : props.notSelectedTextColor || constants.colors.white;
  return (
    <Tappable
      isDisabled={props.isDisabled}
      key={props.iconName || props.iconUrl}
      onTap={() => props.onTap(props.id)}
      containerStyle={{ ...props.containerStyle }}
    >
      <div className="chart-tab-container"
        style={{
          backgroundColor: isSelected
            ? props.selectedBackgroundColor || constants.colors.white
            : props.notSelectedBackgroundColor || constants.colors.w_inactiveChartTabColor,
          ...props.style,
        }}
      >
        <div className={props.className}>
          {props.iconUrl != null ? (
            <NetworkImage
              style={props.isDisabled ? { opacity: 0.2 } : {}}
              size={icon.iconSizes.MICRO}
              iconUrl={props.iconUrl}
              color={textColor}
            />
          ) : (
              <icon.Icon
                color={textColor}
                style={props.isDisabled ? { opacity: 0.2 } : {}}
                name={props.iconName}
                size={icon.iconSizes.MICRO}
              />
            )}
        </div>

        <H2 style={{ marginStart: 12, color: textColor }}>{props.name}</H2>
      </div>
    </Tappable>
  );
};
